import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, Subject, takeUntil } from "rxjs";
import { Pageable } from "app/models/pageable-mode";
import { AppFilter } from "../../../models/app-filter.model";
import { AbPessoa } from "app/abstract/full-pages/pessoa/pessoa.abstract";

@Injectable({
  providedIn: 'root'
})
export class PessoaService extends AbPessoa implements OnDestroy {

  pageablePessoaUnidade: Pageable = new Pageable();
  filterPessoaUnidade: AppFilter = new AppFilter();
  pessoaId: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private readonly destroy$ = new Subject();

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllPerfis() {
    return this.get("perfilPessoas/all/");
  }

  public getAllPessoas(filter: AppFilter) {
    return this.get(`pessoas/filter/${filter.encode()}`);
  }

  public getAllPessoasV2(filter: AppFilter) {
    return this.get(`api/v1/pessoas/${filter.encode()}`);
  }

  public getAllPessoasNome(filter: AppFilter) {
    return this.get(`pessoas/filter/${filter.encode()}`);
  }

  public getAllPessoasDtoAtivasNome(filter: AppFilter) {
    return this.get(`pessoas/filter_pessoas_dto/${filter.encode()}`);
  }

  public getAllPessoaUnidade(filter: AppFilter) {
    return this.get(`pessoa_unidade/filter/${filter.encode()}`)
  }

  public desativarPessoa(id: number) {
    return this.delete("pessoas/desativar/", id);
  }

  getPessoaLogada() {
    return this.get("pessoas/pessoa_logada");
  }

  getPessoaDtoLogada() {
    return this.get("pessoas/pessoa_dto_logada");
  }

  getPessoaUnidade() {
    this.getAllPessoaUnidade(new AppFilter())
      .pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
        this.pageablePessoaUnidade = data
      });
  }

  salvar(pessoa): Observable<any> {
    return this.save("pessoas/", pessoa);
  }

  getPessoa(id: number): Observable<any> {
    return this.get("pessoas/", id);
  }

  getPessoaById(id: number, isSigma: boolean): Observable<any> {
    return this.get(`pessoas/integracao/${id}/${isSigma}`);
  }

  public getPessoasdaUnidade(filter: AppFilter) {
    return this.get(`pessoas/filter_unidade/${filter.encode()}`);
  }

  public getAllByUnidadeId(unidadeId: number) {
    return this.get("pessoas/unidade/", unidadeId);
  }

  public getRegistarAcessoPessoaLogada() {
    return this.get("pessoas/registrar_primeiro_acesso/");
  }

  public getAllPessoasAtivasPortariaDto(filterType: string, typed?: string) {
    return this.get(`pessoas/all/pessoas_ativas_portaria/${filterType}/${typed}`);
  }

  public vincularPessoas(pessoasId: Array<number>, unidadeId): Observable<any> {
    return this.save(`pessoas/vincular_pessoas_unidade/${unidadeId}`, pessoasId);
  }

  public desvincularPessoas(pessoaId, unidadeId): Observable<any> {
    return this.get(`pessoas/desvincular_pessoa_unidade/${unidadeId}/${pessoaId}`);
  }

  public getAllPessoaUnidadeAtivasByUnidadeId(filter: AppFilter) {
    return this.get(`pessoa_unidade/unidade/filter/${filter.encode()}`);
  }

  public getAllPessoaUnidadeAtivasByPessoaId(pessoaId: number) {
    return this.get(`pessoa_unidade/pessoa/${pessoaId}`);
  }

  public checkVinculoUnidadePessoaDocumento(unidadeId, documento: string) {
    return this.get(`pessoa_unidade/check_pessoa_documento/${unidadeId}/${documento}`);
  }

  public getPessoasCredenciais(): Promise<any> {
    return this.get('pessoas/credenciais').toPromise();
  }

  public getIdPessoaIntegrador(): Observable<any> {
    return this.get(`pessoas/id_pessoa_integrador`);
  }

  public getFoto(id: number): Observable<Blob> {
    return this.getBlob(`pessoas/foto/${id}`);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
